(() => {
  const init = (root) => {
    if (!root || root._auroraReviewsInit) return;
    root._auroraReviewsInit = true;

    const list = root.querySelector('[data-aurora-reviews-list]');
    const items = list ? [...list.querySelectorAll('[data-aurora-review-item]')] : [];
    const empty = root.querySelector('[data-aurora-reviews-empty]');
    const filters = [...root.querySelectorAll('[data-aurora-reviews-filter]')];
    const mediaTrack = root.querySelector('[data-aurora-reviews-media-track]');
    const mediaNext = root.querySelector('[data-aurora-reviews-media-next]');

    let activeTag = '';

    const applyFilters = () => {
      if (!list) return;

      const visible = items.filter((item) => {
        if (!activeTag) return true;
        const tags = (item.dataset.tags || '').toLowerCase();
        return tags.includes(activeTag);
      });

      visible.sort((a, b) => {
        const da = Number(a.dataset.date || 0);
        const db = Number(b.dataset.date || 0);
        return db - da;
      });

      items.forEach((item) => {
        item.hidden = true;
      });
      visible.forEach((item) => {
        item.hidden = false;
        list.appendChild(item);
      });

      if (empty) empty.hidden = visible.length > 0;
    };

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        activeTag = (btn.dataset.auroraReviewsFilter || '').toLowerCase();
        filters.forEach((item) => {
          item.classList.toggle('is-active', item === btn);
        });
        applyFilters();
      });
    });

    mediaNext?.addEventListener('click', () => {
      if (!mediaTrack) return;
      const step = Math.max(mediaTrack.clientWidth * 0.8, 180);
      mediaTrack.scrollBy({ left: step, behavior: 'smooth' });
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-aurora-reviews]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target instanceof HTMLElement ? event.target : document);
  });
})();
